import { motion } from 'framer-motion';
import HeroSection from './sections/HeroSection';
import InnovationStrip from './sections/InnovationStrip';
import InnovationSection from './sections/InnovationSection';
import FeaturesSection from './sections/FeaturesSection';
import AboutSection from './sections/AboutSection';
import ProgramsSection from './sections/ProgramsSection';
import CombinedSection from './sections/CombinedSection';
import ContactSection from './sections/ContactSection';
import NewsSection from './sections/NewsSection';

const HomePage = () => {
  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 0.5 }}
    >
      <InnovationStrip />
      <HeroSection />
      <NewsSection />
      <InnovationSection />
      <FeaturesSection />
      <AboutSection />
      <ProgramsSection />
      <CombinedSection />
      <ContactSection />
    </motion.div>
  );
};

export default HomePage;
